module.exports = __webpack_public_path__ + "96d42196935ef920c0e8fd51e1af190d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/page-down.png
// module id = 711
// module chunks = 0